<template>
  <b-card
    v-if="data"
    class="card-transaction"
    no-body
  >
    <b-card-header>
      <b-card-title class="chart-title mb-0">
        {{ $t('To Be Invoices') }}
      </b-card-title>
      <b-button
        v-if="showRefreshButton"
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        size="sm"
        variant="outline-primary"
        class="widgetrefresh-button d-sm-flex align-items-center justify-content-center shadow-custom"
        :style="cardBorder"
        @click="refreshWidget"
      >
        <feather-icon
          icon="RefreshCwIcon"
          class="mr-50 refresh-icon"
        />
        <span class="align-middle refresh-span" />
        <time-ago
          class="timeAgo"
          :datetime="lastUpdatedAt"
          refresh
          locale="en"
          :long="true"
          :style="{color: '#1C1F32'}"
        />
      </b-button>
    </b-card-header>

    <b-card-body class="mt-1">
      <b-row>
        <b-col
          v-for="transaction in data"
          :key="transaction.mode"
          md="12"
          lg="6"
          class="mb-2"
        >
          <b-media
            no-body
            class="stat-card"
            :class="`circle-${transaction.mode.replace(/\s+/g, '').toLowerCase()}`"
            :style="{ backgroundColor: transaction.bgcolor }"
          >
            <b-media-aside class="d-flex transaction-item align-items-center justify-content-center mb-2">
              <b-avatar
                size="64"
                :style="{ backgroundColor: transaction.avatarVariant, color: transaction.iconColor }"
              >
                <feather-icon
                  size="32"
                  :icon="transaction.avatar"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="ml-2">
              <div class="font-weight-bolder text-dark mb-25 value">
                {{ __numberWithCommas(transaction.payment, 2) }}
              </div>
              <h6 class="font-weight-bolder transaction-title">
                {{ $t(transaction.mode) }}
              </h6>
              <!-- <small>{{ transaction.types }}</small> -->
            </b-media-body>
          </b-media>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BMediaBody,
  BMedia,
  BMediaAside,
  BAvatar,
  BRow,
  BCol,
  BButton,
} from 'bootstrap-vue'
import { TimeAgo } from 'vue2-timeago'
import RefreshMixin from '@/@core/mixins/ui/refresh'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BMediaBody,
    BMedia,
    BMediaAside,
    BAvatar,
    BRow,
    BCol,
    TimeAgo,
    BButton,
  },
  mixins: [RefreshMixin],
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    lastUpdatedAt: {
      type: String,
      default: null,
    },
    queue: {
      type: String,
      required: true,
    },
    showRefreshButton: {
      type: Boolean,
      default: true, // or false, depending on your default preference
    },
  },
  computed: {
    chunkedData() {
      // Split data into chunks of 2
      const chunkSize = 2
      const result = []
      for (let i = 0; i < this.data.length; i += chunkSize) {
        result.push(this.data.slice(i, i + chunkSize))
      }
      return result
    },
    cardBorder() {
      return {
        border: '1px solid var(--primary) !important',
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../@core/scss/vue/pages/widget-refresh.scss';
@media (max-width: 1024px) {
  .transaction-item {
    display: flex;
  }
}
@media (max-width: 264px) {
  .transaction-item {
    flex-direction: column;
  }
}
@media (max-width: 1024px) {
  .stat-card {
    width: 100% !important;
  }
  .transaction-item {
    margin-bottom: 1rem;
  }
  .d-flex {
    flex-direction: column !important;
  }
}
.transaction-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100px; /* or any fixed/min height that fits your design */
}
.d-flex {
  align-items: stretch;
}
.stat-card {
  width: 100%;
  height: 128px;
  border-radius: 20px;
  padding: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  margin-left: 0;
  position: relative;
  overflow: hidden;
}
.stat-card .font-small-3 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.value {
  font-size: 20px; /* Increase this value as needed */
}
.stat-card::before {
  content: "";
  position: absolute;
  width: 160px;       /* adjust size */
  height: 160px;      /* adjust size */
  border-radius: 50%;
  left: -52px;        /* move circle horizontally */
  top: -19px;          /* move circle vertically */
  background: rgba(182, 43, 43, 0.35); /* white circle opacity */
  mix-blend-mode: normal;
}
.circle-collectedcod::before {
  background: rgb(246, 240, 228);
}
.circle-deliverycharge::before {
  background: rgb(214, 252, 231);
}

.circle-commission::before {
  background: rgb(216, 232, 241);
}

.circle-invoicevalue::before {
  background: rgb(226, 210, 240);
}
.refresh-icon {
  color: #1C1F32;
}
</style>
